import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Toolbar,
  Sort,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { GetReceiveLogDetailByid } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";

const ViewReceiveLog = () => {
  const navigate = useNavigate();
  let param = useParams();
  const po_id = param.po_id;
  const [receiveLog, setReceiveLog] = useState("");
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const ReceiveGrid = [
    {
      field: "log_id",
      headerText: "Log#",
      minWidth: "70",
      width: "70",
      maxWidth: "75",
      textAlign: "center",
    },
    {
      field: "item_no",
      headerText: "#",
      minWidth: "35",
      width: "40",
      maxWidth: "40",
      textAlign: "right",
    },
    {
      field: "part_number",
      headerText: "Part No",
      minWidth: "100",
      width: "105",
      maxWidth: "130",
      textAlign: "left",
    },
    {
      field: "part_description",
      headerText: "Part Description",
      minWidth: "140",
      width: "220",
      maxWidth: "440",
      textAlign: "left",
    },
    {
      field: "quantity",
      headerText: "Qty",
      minWidth: "50",
      width: "50",
      maxWidth: "60",
      textAlign: "right",
    },
    {
      field: "quantity_recv",
      headerText: "Qty Rcv",
      minWidth: "80",
      width: "80",
      maxWidth: "85",
      textAlign: "right",
    },
    {
      field: "quantity_reject",
      headerText: "Qty Rej",
      minWidth: "75",
      width: "80",
      maxWidth: "85",
      textAlign: "right",
    },
    {
      field: "last_quantity_recv",
      headerText: "Rng Qty Rcv",
      minWidth: "105",
      width: "105",
      maxWidth: "110",
      textAlign: "right",
    },
    {
      field: "last_quantity_reject",
      headerText: "Rng Qty Rej",
      minWidth: "105",
      width: "105",
      maxWidth: "110",
      textAlign: "right",
    },
    {
      field: "recv_by",
      headerText: "Rcv By",
      minWidth: "80",
      width: "100",
      maxWidth: "180",
      textAlign: "left",
    },
    {
      field: "recv_date",
      headerText: "Rcv Date",
      type: "date",
      format: "dd/MM/yyyy",
      minWidth: "90",
      width: "90",
      maxWidth: "100",
      textAlign: "Center",
    },
    {
      field: "date_code",
      headerText: "Date Code",
      minWidth: "100",
      width: "110",
      maxWidth: "150",
      textAlign: "Center",
    },
    {
      field: "lot_code",
      headerText: "Lot #",
      minWidth: "70",
      width: "75",
      maxWidth: "130",
      textAlign: "Center",
    },
    {
      field: "mfg_date",
      headerText: "Mfg Date",
      type: "date",
      format: "dd/MM/yyyy",
      minWidth: "90",
      width: "90",
      maxWidth: "100",
      textAlign: "Center",
    },
    {
      field: "note",
      headerText: "Notes",
      minWidth: "70",
      width: "75",
      maxWidth: "350",
      textAlign: "left",
    },
    {
      field: "mfg_name",
      headerText: "Mfg Name",
      minWidth: "95",
      width: "100",
      maxWidth: "150",
      textAlign: "left",
    },
    {
      field: "mfg_pn",
      headerText: "Mfg PN",
      minWidth: "80",
      width: "85",
      maxWidth: "130",
      textAlign: "left",
    },
  ];

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Purchase");
  };

  useEffect(() => {
    if (po_id) {
      TimeoutUtility.resetTimeout();
      setloading(true);
      trackPromise(
        GetReceiveLogDetailByid(po_id)
          .then((result) => setReceiveLog(result.data || []))
          .catch((err) => console.log(err.message))
          .finally(() => setloading(false)),
      );
    }
  }, [po_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="RECEIVE LOG DETAILS" />
      <Container className="g-0 form-container" fluid="true">
        <Row xs={1} sm={1} className="p-0 justify-content-center">
          <Col md="auto p-0">
            <Button
              margin="10px"
              padding="20px"
              text="Back"
              onClick={handleBackClick}
            />
          </Col>
        </Row>
        {loading || promiseInProgress ? (
          <LoadingIndicator />
        ) : (
          <GridComponent
            dataSource={receiveLog}
            height="calc(62vh - 60px)"
            allowSorting
            allowResizing
            className="custom-grid1"
            rowHeight={30}
            toolbar={["Search"]}
          >
            <ColumnsDirective>
              {ReceiveGrid.map((item, index) => (
                <ColumnDirective key={index} {...item} />
              ))}
            </ColumnsDirective>
            <Inject services={[Resize, Toolbar, Sort]} />
          </GridComponent>
        )}
      </Container>
    </div>
  );
};

export default ViewReceiveLog;
